import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';

const styles = createStyles(() => ({
  root: {
    display: 'contents',
    marginTop: '4px',
    width: '100%',
    textDecoration: 'none',
    boxShadow: '1px 2px 4px 0px rgba(0, 0, 0, 0.2)',
    padding: '0 41px 0 20px',

    '&:hover td': {
      backgroundColor: '#F4F7F8',
    }
  },
  details: {
    zIndex: 1,
    backgroundColor: 'transparent',
    display: 'grid',
    gridTemplateColumns: 'minmax(220px, 1fr) minmax(350px, 1fr) minmax(140px, 1fr)  minmax(270px, 1fr)'
  },
  detailItem: {
    color: '#4A4A4A',
    position: 'relative',
    boxShadow: '4px 2px 4px 0px rgba(0, 0, 0, 0.2)',
    backgroundColor: '#FFFFFF',
    marginTop: '4px',
    padding: '15px 0',
    '&:first-child': {
      paddingLeft: '20px',
    },
  },
  state: {
    color: '#4A4A4A',
    fontSize: '12px',
    fontWeight: 700,
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '4px 2px 4px 0px rgba(0, 0, 0, 0.2)',
    backgroundColor: '#FFFFFF',
    position: 'relative',
    marginTop: '4px',
  },
  stateText: {
    border: '1px solid #CFDDE2',
    display: 'block',
    padding: '4px 6px',
    borderRadius: '8px',
    backgroundColor: '#F4F7F8',
  },
  middleEllipsisOverflowContainer: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  middleEllipsisOverflowLeft: {
    whiteSpace: 'normal',
    overflow: 'hidden',
    display: 'inline-block',
    maxWidth: '50%',
  },
  middleEllipsisOverflowRight: {
    display: 'inline-block',
    maxWidth: '50%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    direction: 'rtl',
    height: '1rem',
  },
  middleEllipsisOverflowWrap: {
    width: '100%',
    height: '1rem',
    //overflowWrap: 'break-word',
    //wordWrap: 'break-word',
    //hyphens: 'auto',
    //overflow: 'hidden',
    wordBreak: 'break-all',
  },
  middleEllipsisOverflowRevertToLtr: {
    direction: 'ltr',
  },
  middleEllipsisOverflowDummyElement: {
    fontSize: '0',
  },
  ellipsisTextOverflow: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    width: '100%',
    display: 'inline-block',
  },

}));

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);
